import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LogoService {
  constructor() { }

  setLogo(url) {
    document.getElementById('webLogo').setAttribute('href', url);
  }

}
